import React from 'react';
import { useWrapRequest } from 'use-wrap-request';
import { TenantCorporateContext } from '..';
import { userSearchDebounce } from '../../components/hooks/use-search';
import { useSearchReducer } from '../../components/hooks/useSearchReducer';
import { CellProps, TableComponent } from '../../components/table';
import { CompanyAccountDto } from '../../core/api/CorporateClient';
import { CopyEmailButton } from '../copy-email-button';

export const TenantUsers = () => {
    const corporateClient = React.useContext(TenantCorporateContext);
    const [searchParams, dispatch] = React.useReducer(useSearchReducer, {
        size: 30,
        page: 0
    });
    const { setSearchTerm } = userSearchDebounce(dispatch);

    const users = useWrapRequest(
        async (searchParams) => {
            const result =
                await corporateClient.support.companyAccountSupportControllerGetPage(
                    searchParams
                );

            return { ...result.data, content: result.data.content || [] };
        },
        {
            defaultData: { content: [] },
            deps: [searchParams]
        }
    );

    return (
        <TableComponent<CompanyAccountDto[]>
            items={users}
            columns={[
                { Header: 'First Name', accessor: 'firstName' },
                { Header: 'Last Name', accessor: 'lastName' },
                { Header: 'Role', accessor: 'role' },
                {
                    Header: 'Email',
                    Cell: ({
                        row: {
                            original: { email }
                        }
                    }: CellProps<CompanyAccountDto>) => (
                        <CopyEmailButton email={email} />
                    )
                }
            ]}
            onSearchChange={(val) => void setSearchTerm(val)}
            onPageSizeChange={(size) => dispatch({ type: 'size', size })}
            onChangePage={(page) => void dispatch({ type: 'page', page })}
        />
    );
};

export default TenantUsers;
